/**
* Hero With Details JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero With Details component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'hero-with-details',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.hero-with-details__sidebar-trigger' ).on( 'toggleBefore', function( e ) {
        $( $( e.target ).attr( 'data-toggle-target' ) ).find( '.hero-with-details__sidebar-inner__content' ).slideToggle();


        if ( $( this ).hasClass( 'is-open' ) ) {
          $( '.hero-with-details' ).removeAttr( 'style' );
        } else {
          setTimeout( function() {
            console.log( $( '.hero-with-details' ).height() );
            console.log( $( $( e.target ).attr( 'data-toggle-target' ) ).find( '.hero-with-details__sidebar-inner__content' ).height() );
            if ( $( '.hero-with-details' ).height() < $( $( e.target ).attr( 'data-toggle-target' ) ).find( '.hero-with-details__sidebar-inner__content' ).height() ) {
              console.log( 'BOOM' );
              $( '.hero-with-details' ).height( $( $( e.target ).attr( 'data-toggle-target' ) ).find( '.hero-with-details__sidebar-inner__content' ).height() + 16 );
            }
          }, 500 );
        }
      } );

      /* Set up arias for blog sidebar toggles */
      toggleHeroWithDetailsSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleHeroWithDetailsSidebarAriaVisibility();
      } );

      function toggleHeroWithDetailsSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.hero-with-details__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.hero-with-details__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.hero-with-details__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-with-details', COMPONENT );
} )( app );
